export function normalizeLiveMapTimestampSeconds(value) {
  const timestamp = Number(value);

  if (!Number.isFinite(timestamp) || timestamp <= 0) {
    return 0;
  }

  return timestamp > 10_000_000_000
    ? Math.round(timestamp / 1000)
    : Math.round(timestamp);
}

export function expireLiveMapRecords(
  currentRecords,
  { now = Date.now(), staleAfterMs = 90000, expireByUpdatedAt = true } = {},
) {
  const nextRecords = { ...currentRecords };

  for (const [vehicleId, vehicle] of Object.entries(nextRecords)) {
    const updatedAtMs = normalizeLiveMapTimestampSeconds(vehicle?.updatedAt) * 1000;
    const lastSeenAt = Number(vehicle?.lastSeenAt) || 0;
    const isStaleBySeenAt = now - lastSeenAt > staleAfterMs;
    const isStaleByUpdatedAt =
      expireByUpdatedAt &&
      updatedAtMs > 0 &&
      now - updatedAtMs > staleAfterMs;

    if (isStaleBySeenAt || isStaleByUpdatedAt) {
      delete nextRecords[vehicleId];
    }
  }

  return nextRecords;
}

export function mergeLiveMapFeed(
  currentRecords,
  payload,
  { defaultStaleAfterMs = 90000 } = {},
) {
  const nextRecords = payload?.snapshot ? {} : { ...currentRecords };
  const generatedAt = Number(payload?.generatedAt) || Date.now();
  const staleAfterMs =
    Number(payload?.staleAfterMs) || defaultStaleAfterMs;
  const shouldExpireByUpdatedAt = payload?.expireByUpdatedAt !== false;

  for (const vehicle of payload?.vehicles || []) {
    const vehicleId = vehicle?.vehicleId || vehicle?.id;

    if (!vehicleId) {
      continue;
    }

    nextRecords[vehicleId] = {
      ...vehicle,
      vehicleId,
      lastSeenAt: generatedAt,
    };
  }

  return expireLiveMapRecords(nextRecords, {
    now: generatedAt,
    staleAfterMs,
    expireByUpdatedAt: shouldExpireByUpdatedAt,
  });
}
